import { fontSmoothing, getFontFamily } from '../../typography';
import idsTokensDefault from '../../utils/tokens/idsTokens';

export const classes = (idsTokens = idsTokensDefault) => ({
  root: {
    borderRadius: idsTokens.segmentedControl.default.radius.group,
    border: `1px solid ${idsTokens.segmentedControl.default.color.border.unselected}`,
    backgroundColor: idsTokens.segmentedControl.default.color.background.unselected.enabled,
    color: idsTokens.segmentedControl.default.color.content.unselected.enabled,
    fontFamily: getFontFamily(idsTokens),
    ...fontSmoothing,
    '&.MuiToggleButton-sizeMedium, &.MuiToggleButton-sizeSmall': {
      letterSpacing: 0.28,
      '&.Mui-disabled': {
        backgroundColor: idsTokens.segmentedControl.default.color.background.unselected.disabled,
        color: idsTokens.segmentedControl.default.color.content.unselected.disabled,
      },
      '&:hover': {
        backgroundColor: idsTokens.segmentedControl.default.color.background.unselected.hover,
        color: idsTokens.segmentedControl.default.color.content.unselected.hover,
      },
      '&:active': {
        backgroundColor: idsTokens.segmentedControl.default.color.background.unselected.pressed,
        color: idsTokens.segmentedControl.default.color.content.unselected.pressed,
      },
      '&&:not(:first-of-type)': {
        borderLeft: `1px solid ${idsTokens.segmentedControl.default.color.border.unselected}`,
        marginLeft: 0,
      },
      '&:not(:last-child)': {
        borderRight: 0,
      },
      '&&.Mui-selected': {
        backgroundColor: idsTokens.segmentedControl.default.color.background.selected.enabled,
        borderColor: idsTokens.segmentedControl.default.color.border.selected.enabled,
        color: idsTokens.segmentedControl.default.color.content.selected.enabled,
        '&.Mui-disabled': {
          backgroundColor: idsTokens.segmentedControl.default.color.background.selected.disabled,
          color: idsTokens.segmentedControl.default.color.content.selected.disabled,
          border: `1px solid ${idsTokens.segmentedControl.default.color.border.selected.disabled}`,
          borderRight: 0,
          '& + .MuiButtonBase-root': {
            borderLeft: `1px solid ${idsTokens.segmentedControl.default.color.border.selected.disabled}`,
          },
        },
        '&:hover': {
          backgroundColor: idsTokens.segmentedControl.default.color.background.selected.hover,
          borderColor: idsTokens.segmentedControl.default.color.border.selected.enabledHover,
          color: idsTokens.segmentedControl.default.color.content.selected.hover,
        },
        '&:active': {
          backgroundColor: idsTokens.segmentedControl.default.color.background.selected.pressed,
          borderColor: idsTokens.segmentedControl.default.color.border.selected.enabledPressed,
          color: idsTokens.segmentedControl.default.color.content.selected.pressed,
        },
      },
    },

    '&.MuiToggleButton-sizeMedium': {
      minHeight: idsTokens.segmentedControl.default.sizing.standard.minHeight,
      minWidth: idsTokens.segmentedControl.default.sizing.standard.minWidth,
      padding: `0px ${idsTokens.segmentedControl.default.spacing.standard.horizontalPadding}`,
      fontSize: idsTokens.typography.font.size.base,
      lineHeight: idsTokens.typography.lineHeight.base,
      letterSpacing: idsTokens.typography.spacing.letter.lg,
      fontWeight: idsTokens.typography.font.weight.medium,
      '& svg': {
        fontSize: 20,
        padding: 0.1,
        boxSizing: 'content-box',
      },
    },

    '&.MuiToggleButton-sizeSmall': {
      minHeight: idsTokens.segmentedControl.default.sizing.small.minHeight,
      minWidth: idsTokens.segmentedControl.default.sizing.small.minWidth,
      padding: `0px ${idsTokens.segmentedControl.default.spacing.small.horizontalPadding}`,
      fontSize: idsTokens.typography.font.size.sm,
      lineHeight: idsTokens.typography.lineHeight.sm,
      letterSpacing: idsTokens.typography.spacing.letter.md,
      fontWeight: idsTokens.typography.font.weight.medium,
      '& svg': {
        fontSize: 16,
        padding: 0.1,
        boxSizing: 'content-box',
      },
    },
    '&:focus-visible': {
      outlineColor: 'transparent',
      outlineOffset: -2,
      outlineStyle: 'solid',
      outlineWidth: 2,
      backgroundColor: idsTokens.segmentedControl.default.color.focus.fill,
      backgroundBlendMode: 'multiply',
      boxShadow: `inset 0 0 0 2px ${idsTokens.segmentedControl.default.color.focus.outline}, inset 0 0 0 4px ${idsTokens.segmentedControl.default.color.focus.shadow}`,
      zIndex: 1,
    },
  },
  label: {
    position: 'relative',
  },
});
